import React, {useEffect} from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import LogCell from './logCell';
import Date from "../../WorkkardDetail/MiddlePanelContainer/getDate";

const LogGroup = (props) => {
    const { selectedDiary } = useSelector(state => ({
        selectedDiary: state.diaries.listing.selectedDiary,
    }), shallowEqual);
    
    return (
        <div data-test="Log Group" className="logListingGroup detailListingGroup ">
            <div className="date"><Date inputDate={props.data} /></div>
            {props.data.data.map((d) => {
                return <React.Fragment key={d.id}><LogCell data={d.data} id={d.id}/></React.Fragment>
            })}
        </div>
    );
}

export default LogGroup;